import { Component, EventEmitter, Input, OnInit } from '@angular/core';

import { IItemRenderer } from '../../interfaces/item-renderer.table';
import { IMenuItemRendererOptions } from './menu-item-renderer-options';

@Component({
  selector: 'opt-menu-item-renderer',
  templateUrl: './menu-item-renderer.component.html',
  styleUrls: ['./menu-item-renderer.component.scss'],
})
export class MenuItemRendererComponent implements OnInit, IItemRenderer {
  @Input() events: IMenuItemRendererOptions;

  @Input() id: string;
  @Input() value: any;

  constructor() {}

  ngOnInit(): void {}

  public onClick(action: EventEmitter<any>): void {
    if (action) {
      action.emit(this.id);
    }
  }

  public isDisabled(isDisabledFunction: (item) => boolean): boolean {
    if (!isDisabledFunction) {
      return false;
    }
    return isDisabledFunction(this.value);
  }
}
